<template lang="html">
	<div class="inner-modal">
		<div class="head-modal head-modal-light row">
			<div class="left">
				<div class="head-modal-title-light text-center">
				Confirmation de paiement
				</div>
			</div>
		</div>
    <div class="body-modal">
			<form class="form-ui column default-form-ui">
				<p>Une confirmation de paiement est nécessaire afin de valider votre abonnement.</p>
				<div class="ctn-cta row">
					<div class="btn btn-red" @click="send">Confirmer</div>
				</div>
			</form>
		</div>
  </div>
</template>

<script>
export default {
	props: ['data'],
	components: {
	},
	data () {
		return {
		}
	},
	methods: {
		send () {
			this.$emit('close')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/views/Documents/ConfirmPaymentModal/ConfirmPayment.vue